export default {
  new: state => !!state.new,
  messages: state => state.messages
};
